<template>
  <div>
    <section v-if="selectedAnnotation==null" class="lms-container">
      <div class="content">
        <div class="breadcrumb" style="border: none !important;"></div>

        <div class="modules-content" style="margin-top:0px;">
          <div class="module-item" data-id="1" data-module-lessons="23">
            <div class="title-content custom-grid">
              <h3 class="module-title" style="font-size: 14px;">Anotações</h3>

              <span></span>

              <span></span>

              <span></span>
            </div>

            <li class="lesson-subtitle custom-grid-inactives">
              <span class="lesson-title">Módulo</span>
              <span class="lesson-title">Aula</span>
              <span class="lesson-progress">Vídeo</span>
              <span class="lesson-option"></span>
            </li>

            <ul class="lessons-list">
              <li
                v-for="(data,index) in annotations"
                :key="index"
                class="lesson custom-grid-inactives"
                data-id="64"
                data-videos="1"
              >
                <span class="lesson-title">{{data.moduleName}}</span>
                <span class="lesson-title">{{data.lessonTitle}}</span>
                <span class="lesson-title">{{data.videoTitle}}</span>
                <span class="lesson-option">
                  <a @click="selectedAnnotation=data" href="#">Visualizar</a>
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <view-annotation @close="selectedAnnotation=null" v-else :lessonName="selectedAnnotation.lessonTitle" :videoId="selectedAnnotation.videoId" :annotationJson="JSON.parse(selectedAnnotation.content)" />
  </div>
</template>

<style lang="scss" scoped>
.custom-grid-inactives {
  @media (min-width: 1024px) {
    grid-template-columns: 1fr 1fr 1fr 1fr !important;
  }
}
</style>

<script>
import axios from "axios";
import ViewAnnotation from "./ViewAnnotation";

export default {
  props: {},
  components: {
    ViewAnnotation
  },
  data() {
    return {
      selectedAnnotation:null,
      selectedVideoId: 0,
      selectedContent: {},
      annotations: []
    };
  },
  methods: {},
  created() {
    const path = this.$global.endpoint + "/video/annotation/getall";
    axios
      .get(path)
      .then(res => {
        this.annotations = res.data;
        console.log(this.annotations);
      })
      .catch(error => {
        console.error(error);
      });
  }
};
</script>
